import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, Location} from '@angular/common';
import {NavigationEnd, NavigationStart, Router} from '@angular/router';

@Injectable()
export class ScrollPositionService {
  lastScrollPositions = {};
  isHistoryMove = false;

  constructor(private router: Router, private location: Location, @Inject(PLATFORM_ID) private platformId: Object) {
    location.subscribe(() => {
      console.log('History move');
      this.isHistoryMove = true;
    }, null, () => {
      console.log('Return');
    });
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationStart) {
        this.setScrollPosition();
      }
    });
  }

  setScrollPosition() {
    if (isPlatformBrowser(this.platformId)) {
      console.log('Router url: ' + this.router.url);
      console.log('Window height is: ' + document.getElementsByTagName('body')[0].clientHeight);
      this.lastScrollPositions[this.router.url] = window.scrollY;
      console.log(this.lastScrollPositions);
    }
  }

  scrollToLast() {
    if (isPlatformBrowser(this.platformId)) {
      const targetPosition = this.lastScrollPositions[this.router.url];
      console.log('Window height is: ' + document.getElementsByTagName('body')[0].clientHeight);
      console.log('Scrolling to: ' + targetPosition);
      window.scrollTo(0, targetPosition);
      this.isHistoryMove = false;
    }
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  autoScroll() {
    if (isPlatformBrowser(this.platformId)) {
      console.log('Auto scroll');
      if (this.isHistoryMove) {
        console.log('Lets scroll');
        this.scrollToLast();
      } else {
        console.log('Scrolling to top');
        this.scrollToTop();
      }
    }
  }

  scrollPastHero() {
    if (isPlatformBrowser(this.platformId)) {
      const hero = document.getElementsByClassName('hero')[0];
      window.scroll({top: hero.clientHeight, left: 0, behavior: 'smooth'});
    }
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/scroll-position.service.ts